/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const taxDataSchema = z.object({
	registered: z.boolean(),
	data: z.object({
		id: z.string(),
		value: z.string(),
		verification: z.union([
			z.literal('pending'),
			z.literal('unavailable'),
			z.literal('unverified'),
			z.literal('verified'),
		]),
	}).nullable(),
	taxRate: z.object({ percentage: z.number(), displayName: z.string() }),
	showWarning: z.boolean(),
	preventPurchase: z.boolean(),
})

export type TaxDataSchema = z.infer<typeof taxDataSchema>
